import React from 'react';
import useAdminTheme from '../admindashboard/useTheme.js';
import AppShell from './app-shell';
import './routecore.css';
import { cn } from './core';

// Embeds the RouteCore (itinerary studio) inside the new admin dashboard.
// Theme is driven by the NEW ADMIN DASHBOARD'S Sun/Moon toggle in the
// header (NewAdminDashboard/Header.js L60-L86) which writes to
// `useTheme` (admindashboard/useTheme.js) — single source of truth.
// We read `isLight` and apply `.theme-light` to the RouteCore root so
// the scoped CSS at `.routecore-app.theme-light` fires.
export default function RouteCoreApp() {
  const { isLight } = useAdminTheme();
  return (
    <div
      className={cn(
        'routecore-app relative rounded-2xl overflow-hidden border border-black/5 shadow-xl',
        isLight && 'theme-light',
      )}
      data-testid="routecore-app"
      data-theme={isLight ? 'light' : 'dark'}
      style={{ minHeight: 'calc(100vh - 180px)' }}
    >
      <AppShell />
    </div>
  );
}
